module.exports = "<textarea class=\"c-input\" ng-model=\"model[options.key]\" style=\"height: 10rem; resize: auto\" />"


/*****************
 ** WEBPACK FOOTER
 ** ./src/templates/formly/textarea.html
 ** module id = 542
 ** module chunks = 0
 **/